import { Routes } from '@angular/router';
import { SidenavComponent } from './pages/sidenav/sidenav.component';
import { authGuard } from './shared/auth/auth-guard.service';


export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
  path: 'caratred_sso',
  loadComponent: () =>
    import('./auth/login/login.component').then((m) => m.LoginComponent),
},
  
  {
    path: 'change-password',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./auth/change-password/change-password.module').then(
        (m) => m.ChangePasswordModule
      ),
  },
  {
    path: 'home',
    canActivate: [authGuard],
    component: SidenavComponent,
    children: [
      {
        path: 'company',
        loadComponent: () =>
          import('./pages/companies/companies.component').then(
            (m) => m.CompaniesComponent
          ),
      },
      // {
      //   path: 'change-password',
      //   loadComponent: () =>
      //     import('./auth/change-password/change-password.component').then(
      //       (m) => m.ChangePasswordComponent
      //     ),
      // },
      {
        path: 'modules',
        loadComponent: () =>
          import('./pages/modules/modules.component').then(
            (m) => m.ModulesComponent
          ),
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./pages/products/products.component').then(
            (m) => m.ProductsComponent
          ),
      },
       {
        path: 'admin-settings',
        loadComponent: () =>
          import('./pages/admin-settings/admin-settings.component').then(
            (m) => m.AdminSettingsComponent
          ),
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./pages/users/users.component').then((m) => m.UsersComponent),
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('./pages/roles/roles.component').then((m) => m.RolesComponent),
      },
      {
        path: 'department',
        loadComponent: () =>
          import('./pages/department/department.component').then(
            (m) => m.DepartmentComponent
          ),
      },
      {
        path: 'permissions',
        loadComponent: () =>
          import('./pages/permissions/permissions.component').then(
            (m) => m.PermissionsComponent
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/settings/settings.component').then(
            (m) => m.SettingsComponent
          ),
      }, {
        path:'workflow',
        loadComponent:()=>
           import('./pages/workflows/workflows.component').then(
            (m) => m.WorkflowsComponent
          ),
      },
      { path: '**', redirectTo: 'company', pathMatch: 'full' },
    ],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
